import { useSelector } from 'react-redux'
import { selectMeta } from '@/redux/meta/selector'
import {
  useGetOPAccessTokenQuery,
  useRetrieveCustomerInfoQuery,
} from '@/services/local'
import { decodeToken } from '@/utils/jwt'
import { readLocalStorage, writeLocalStorage } from '@/utils/clientStorage'
import { useSearchParams } from 'next/navigation'
import { useRef } from 'react'

const useAuth = (options?: { skip?: boolean }) => {
  const meta = useSelector(selectMeta)
  const searchParams = useSearchParams()
  const isRefetched = useRef(false)

  const respCustomerInfo = useRetrieveCustomerInfoQuery(
    {
      cartName: meta.cartName,
    },
    {
      skip:
        options?.skip ||
        !meta.cartName ||
        searchParams?.get('type') === 'invoice',
    },
  )

  const { data: newOPAccessToken } = useGetOPAccessTokenQuery(
    {
      customerId:
        typeof window === 'undefined'
          ? undefined
          : decodeToken(readLocalStorage('accessToken')).customerId,
      menuId: meta?.detailMenuSite?.data?.menu?.id,
    },
    {
      skip:
        typeof window === 'undefined' ||
        !readLocalStorage('accessToken') ||
        !meta?.detailMenuSite?.data?.menu?.id ||
        !['oddle-eats-mobile', 'oddle-eats'].includes(
          searchParams?.get('referrer') || '',
        ) ||
        respCustomerInfo?.data?.data?.errorCode !== 'request_new_access_token',
    },
  )

  if (newOPAccessToken?.data?.data?.accessToken && !isRefetched.current) {
    isRefetched.current = true
    writeLocalStorage('accessToken', newOPAccessToken.data.data.accessToken)
    respCustomerInfo.refetch()
  }

  return respCustomerInfo
}

export default useAuth
